import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import HeroText from '../HeroText';
import styles from './university-hero.css';
import laurelImage from '../images/unis-laurel.svg';

const Laurel = () => h('div', { className: styles.heroImage }, [
    h('img', { src: laurelImage, alt: '' })
]);

const UniversityHero = (props) => {
    const { div } = hh(h);

    return (
        div({className: styles.container }, [
            h(Laurel),
            h(HeroText, {
                className: styles.heroText,
                subText: 'Code at Uni is on a mission to help students acquire the skills they need for the future of work.',
                cta: {
                    href: '/contact',
                    text: 'Contact us'
                }
            }, 'Universities')
        ])
    );
};

export default UniversityHero;



/** WEBPACK FOOTER **
 ** ./src/UniversityHero/index.js
 **/